import React, { FC } from 'react';

import { Box, Divider } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box';

export const DraggableItemDivider: FC<BoxProps> = props => (
  <Box {...props}>
    <Divider component="hr" orientation="vertical" />
  </Box>
);
